// @flow

import { CRASH_EVENT_TAG } from '../../core/crashEvent'
import { collectCrashContext } from './crashContext'

// beforeCapture of the root ErrorBoundary: tags only its own scope, so the crash event
// skips the client filters and sampling. Must never throw, or the crash would be lost.
export const tagCrashScope = (scope: Object) => {
  try {
    scope.setTag(CRASH_EVENT_TAG, '1')
    scope.setTag('force_keep', '1')

    const { customerId } = collectCrashContext()

    if (customerId) scope.setUser({ id: customerId })
  } catch (e) {
    // The event is still sent, only without the tags
  }
}
